import { render, staticRenderFns } from "./JobDeliverables.vue?vue&type=template&id=4e08c1b5&"
import script from "./JobDeliverables.vue?vue&type=script&lang=js&"
export * from "./JobDeliverables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports